<div class="form-group row" *ngIf="SPRADetail">
    <div class="col-sm-6">
        <mat-card>
            <mat-card-title class="font-weight-bold caption-color">SPRA Request Detail</mat-card-title>
            <mat-divider></mat-divider>
            <mat-card-content class="pt-2">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-4">SPRA No</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-6 font-weight-bold">{{SPRADetail.RequestNo}} </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-4">SPRA Date</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-6 font-weight-bold">{{SPRADetail.RequestDate}} </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-4">Requested By</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-6 font-weight-bold">{{SPRADetail.EnteredBy}} </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-4">Valid Till</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-6 font-weight-bold">{{SPRADetail.ValidTill}} </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-4">Branch</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-6 font-weight-bold">{{SPRADetail.OfficeDesc}} </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-4">SPRA Type</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-6 font-weight-bold text-info">{{SPRADetail.IsRental?"Rental":"Outright"}} </div>
                        </div>
                    </div>
                  
                </div>


                <div class="row" *ngIf="!ISService && SPRADetail.IsRental && ProfitTag">
                    <div class="col-sm-12">
                        <div class="form-group row text-left">
                            <h4 class="col-sm-12">
                                <span class="floating badge badge-pill badge-primary ml-2" (click)="OpenEmiDetail()"> EMI Detail </span>
                                <span class="badge badge-pill badge-primary ml-2" (click)="OpenPLDetail()"> PL Detail </span>
                            </h4>
                        </div>
                    </div>
                </div>

                
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6" *ngIf="SPRADetail && !SPRADetail.IsRental">
        <mat-card>
            <mat-card-title class="font-weight-bold caption-color">Payment Terms</mat-card-title>
            <mat-divider></mat-divider>
            <mat-card-content class="pt-2">

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-5">Payment Term</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-5 font-weight-bold">{{SPRADetail.PaymentTerm.Term}} </div>
                        </div>
                    </div>

                    <!-- <div class="col-sm-6" *ngIf="SPRADetail.PaymentTerm.Term=='Credit'"> -->
                    <div class="col-sm-6" *ngIf="SPRADetail.PaymentTerm.Term=='Credit'">
                        <div class="form-group row">
                            <div class="col-sm-5 ">Credit Days</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-5 font-weight-bold">{{SPRADetail.PaymentTerm.CreditDays}} </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

</div>

<div class="form-group row" *ngIf="SPRADetail">
    <div class="col-sm-12">
        <mat-card>
            <mat-card-title class="font-weight-bold caption-color">Ops Part Search</mat-card-title>
            <mat-divider></mat-divider>
            <mat-card-content class="pt-2">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-2 ml-4">Segment</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-4 font-weight-bold">{{SPRADetail?.ProdDetail[0]?.Segment}} </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-6">
                   </div> -->
                </div>
                <div class="col-sm-12">


                    <table class="table">
                        <thead>
                            <tr>
                                <th>Prod Code</th>
                                <th>Description</th>
                                <th>Group</th>
                                <th>Grade</th>
                                <th class="text-right">Quantity</th>

                                <th *ngIf="!ISService && !SPRADetail.IsRental" class="text-right">Price</th>
                                <th *ngIf="!ISService && !SPRADetail.IsRental" class="text-right">Total</th>                                
                                <th *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">Price-List</th>
                                <th *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">Worksheet-Net Sales Price</th>
                                <th *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">LC-Worksheet</th>
                                <th *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">Book LC</th> 
                                
                                <th *ngIf="!ISService && SPRADetail.IsRental" class="text-right">Unit Sale Price</th>
                                <th *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="text-right">Sales Amount</th>
                                <th *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="text-right">Unit Cost(WorkSheet Price)</th>
                                <th *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="text-right">Cost Amount</th>           
            
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of SPRADetail.ProdDetail; let i = index;">
                                <td>
                                  {{item.ProductCode}}
                                </td>
                                <td>
                                    <label>{{item.ProductDesc}}</label>
                                </td>
                                <td>
                                    <label>{{item.PGroup}}</label>
                                </td>
                                <td>
                                    <label>{{item.Grade}}</label>
                                </td>
                                <td class="text-right">
                                    <label>{{item.Quantity}}</label>
                                </td>

                                <td *ngIf="!ISService && !SPRADetail.IsRental" class="text-right">
                                    <label>{{item.UnitPrice}}</label>
                                </td>
                                <td *ngIf="!ISService && !SPRADetail.IsRental" class="text-right">
                                    <label>{{item.TotPrice}}</label>
                                </td>
                                <td *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">
                                    <label>{{item.PriceList}}</label>
                                </td>
                                <td *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">
                                    <label>{{item.WorkSheetNSP}}</label>
                                </td>
                                <td *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">
                                    <label>{{item.WorkSheetLanded}}</label>
                                </td>
                                <td *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="text-right">
                                    <label>{{item.BookingLanded}}</label>
                                </td>

                                <td *ngIf="!ISService && SPRADetail.IsRental" class="text-right">
                                    <label>{{item.UnitSalePrice}}</label>
                                </td>
                                <td *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="text-right">
                                    <label>{{item.SaleAmount}}</label>
                                </td>
                                <td *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="text-right">
                                    <label>{{item.UnitWSCost}}</label>
                                </td>
                                <td *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="text-right">
                                    <label>{{item.UnitWSCost*item.Quantity | number : '1.2-2'}}</label>
                                </td>
                              
                            </tr>

                            <tr *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="6">
                                    <b>Total Discount</b>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotDiscount}}</b></label>
                                </td>
                                <td colspan="4">
                                </td>
                            </tr>
                            
                            <tr *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="6">
                                    <b>Net Sale Price Released</b>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalSaleValue | number : '1.0-0'}}</b></label>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalPriceList | number : '1.0-0'}}</b></label>                            
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalWSNSP | number : '1.0-0'}}</b></label>                   
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalLandedCost | number : '1.0-0'}}</b></label>                            
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalBookLC | number : '1.0-0'}}</b></label>
                                </td>
                            </tr>
                            
                            <tr *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="7">
                                    <b>FG GP(%) BEING REALISED AGAINST THIS ORDER </b>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.GPPriceList }}</b></label>
                                </td>
                                <td class="text-right">
                                     <label><b>{{SPRADetail.PriceRefCalculations?.Product.GPWSNSP}}</b></label> 
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.GPLandedCost}}</b></label> 
                               </td>
                               <td class="text-right">
                                <label><b>{{SPRADetail.PriceRefCalculations?.Product.GPBookLC}}</b></label> 
                                </td>
                            </tr>

                            <tr *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="6">
                                    <b>FG + Serv Net Sale Price Released</b>
                                </td>
                                <td class="text-right"> 
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalFGServSaleValue | number : '1.0-0'}}</b></label>                      
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalFGServPriceList | number : '1.0-0'}}</b></label>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalFGServWSNSP | number : '1.0-0'}}</b></label> 
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalFGServLandedCost | number : '1.0-0'}}</b></label> 
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotalFGServBookLC | number : '1.0-0'}}</b></label> 
                                </td>
                            </tr>

                            <tr *ngIf="!ISService && !SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="7">
                                   <b> Total GP(%) BEING REALISED AGAINST THIS ORDER </b>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.FGServGPPriceList }}</b></label>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.FGServGPWSNSP }}</b></label> 
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.FGServGPLandedCost  }}</b></label> 
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.FGServGPBookLC }}</b></label> 
                                </td>
                            </tr>


                            <!-- ---------------RENTAL PROFIT TR----------------------------------------->
                            <tr *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="6">
                                    <b>Total</b>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotLoanAmount | number : '1.0-0'}}</b></label>
                                </td>
                                <td colspan="4"></td>
                            </tr> 
                            <tr *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="6">
                                    <b>Total Discount</b>
                                </td>
                                <td class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.TotDiscount | number : '1.0-0'}}</b></label>
                                </td>
                                <td colspan="2"></td>
                            </tr> 
                            <tr *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="6">
                                    <b>  Net Sales Value (Order Logging Value)</b>
                                </td>
                                <td class="text-right">
                                    <label><b>{{(SPRADetail.PriceRefCalculations?.Product.TotLoanAmount - SPRADetail.PriceRefCalculations?.Product.TotDiscount) | number : '1.2-2' }}</b></label>
                                </td>
                                <td  class="text-right"> <label class="pr-2"><b>GP</b></label> </td>
                                <td  class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.NetSaleValueVGP | number : '1.2-2' }}%</b></label>
                                </td>
                            </tr> 
                            <tr *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="7">
                                    <b>Profit Without Interest</b>
                                </td>
                                <td  class="text-right"> <label class="pr-2"><b>GP</b></label> </td>
                                <td  class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.ProfitBeforeTax | number : '1.2-2' }}%</b></label>
                                </td>
                            </tr> 
                            <tr *ngIf="!ISService && SPRADetail.IsRental && ProfitTag" class="bg-highlight">
                                <td colspan="7">
                                    <b>Profit With Interest</b>
                                </td>
                                <td  class="text-right"> <label class="pr-2"><b>GP</b></label> </td>
                                <td  class="text-right">
                                    <label><b>{{SPRADetail.PriceRefCalculations?.Product.ProfitBeforeTaxWithInt | number : '1.2-2' }}%</b></label>
                                </td>
                            </tr> 

</tbody>
                    </table>



                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

 <!-- Added By rahul yadav on 30/05/2021 for consignee -->
 <div class="form-group row">
    <div class="col-sm-12" *ngIf="ProfitTag && !ISService && ISSpraHavingFinishGoods && SPRADetail.SaleType!='LL'">
       <app-spra-view-consignee></app-spra-view-consignee>
   </div>
</div>

<div class="form-group row" *ngIf="SPRADetail">
    <div class="col-sm-6">
        <div class="row">
            <div class="col-sm-12">
                <mat-card>
                    <mat-card-title class="font-weight-bold caption-color">Approval Required</mat-card-title>
                    <mat-divider></mat-divider>
                    <mat-card-content class="pt-2">
        
                        <div class="row" *ngIf="SPRADetail.SaleType!='LL'">
                            <div class="col-sm-3 ">Total Customer MIF</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail?.PriceApproval?.TotalCustMif}}</div>
                        </div>
                        <div class="row" *ngIf="SPRADetail.SaleType!='LL'">
                            <div class="col-sm-3 ">Sharp MIF at customer place</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.SharpMifCustomerPlace}}</div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 ">Price Ref Type</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.PriceRefType}}</div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 ">Price Ref No.</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.PriceRef}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 "  >Warranty Month</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.WarrantyMonth}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 "  >Extra Warranty Period</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.ExtraWarrentyPeriod}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType=='LL'">
                            <div class="col-sm-3 "  >TOI</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.TOI}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType=='LL'">
                            <div class="col-sm-3 "  >Incentive Trip For Sales</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.IncentiveSales}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType=='LL'">
                            <div class="col-sm-3 "  >Incentive Trip For Dealer</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.IncentiveDealer}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType=='LL'">
                            <div class="col-sm-3 "  >OverDue</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.OverDue}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType=='LL'">
                            <div class="col-sm-3 "  >Cons Order Value This Month (In K)</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.ConsValueThisMonth}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType=='LL'">
                            <div class="col-sm-3 "  >End Customer Order Copy</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.ECOC}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType!='LL'">
                            <div class="col-sm-3 "  >Warranty Cost</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.WarrentyCost}}</div>
                        </div>

                        <div class="row" *ngIf="SPRADetail.SaleType!='LL'">
                            <div class="col-sm-3 ">Sharp Rental Terms & Condition Aceepted by Customer</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.RentalTermAccept}}</div>
                        </div>

                        <div class="row" *ngIf="!SPRADetail.IsRental && SPRADetail.SaleType!='LL'" >
                            <div class="col-sm-3 ">Day One CSA</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.DayOneCSA?"Yes":"No"}}</div>
                        </div>
                        <div class="row" *ngIf="SPRADetail.SaleType!='LL'">
                            <div class="col-sm-3 ">Black A3 Copy Ratio</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.BlackA3CopyRatio}}</div>
                        </div>
                        <div class="row" *ngIf="SPRADetail.SaleType!='LL'">
                            <div class="col-sm-3 ">Color A3 Copy Ratio</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.PriceApproval?.ColorA3CopyRatio}}</div>
                        </div>
                    </mat-card-content>
                </mat-card>
           
    
            </div>
            
            <div class="col-sm-12 mt-3" *ngIf="!ISService">
                <mat-card>
                    <mat-card-title class="font-weight-bold caption-color" >Net Sale Price Details</mat-card-title>
                    <mat-divider></mat-divider>
                    <mat-card-content class="pt-2">
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 ">BuyBack</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.BuyBack}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 ">BuyBack Remarks</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.BuyBackRemarks}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 ">Resale Value Of Buyback</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.ReSaleValueBuyBack}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 ">Rebate W/O GST</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.RebateWoGST}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 ">Bought Out Items</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.BoughtOutItems}}</div>
                        </div>
                        <div class="row" *ngIf="!SPRADetail.IsRental">
                            <div class="col-sm-3 ">Bought Out Items Remarks</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.BoughtOutItemsRemarks}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 ">Agent Commission</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.AgentCommission}}</div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 ">Installation Commission</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.InstallationCommission}}
                            </div>
                        </div>
                       
                        <!-- Added By rahul yadav on 25/05/2021 -->
                        <div class="row">
                            <div class="col-sm-3 ">Dealer Commission</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.DealerCommission}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 ">Free Item</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.FreeItem}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 ">Any Other Discount</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-8 font-weight-bold">{{SPRADetail.NetSalePriceRealised?.OtherDiscount}}
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        
    </div>
    <div class="col-sm-6" *ngIf="SPRADetail.ComptDetail != undefined">
        <div class="row">
            <div class="col-sm-12">
                <mat-card>
                    <mat-card-title class="font-weight-bold caption-color">Competition Detail</mat-card-title>
                    <!-- <mat-divider></mat-divider> -->
                    <mat-card-content class="pt-2">
                        <table class="table ">
                            <thead>
                                <tr>
                                    <th>SrNo.</th>
                                    <th>Competitor Name</th>
                                    <th>Competitor Model</th>
                                     <!-- Added by rahul yadav 25/05/2021 -->
                                    <th *ngIf="!ISService">Competitor Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let item of SPRADetail.ComptDetail; let i = index;">
                                    <!-- <tr *ngIf="i<SPRADetail.ComptDetail.length-1"> -->
                                    <tr>
                                        <td>
                                            {{i+1}}
                                        </td>
                                        <td>
                                            {{item.CompName}}
                                        </td>
                                        <td>
                                            {{item.CompModel}}
                                        </td>
                                        <!-- Added by rahul yadav 25/05/2021 -->
                                        <td *ngIf="!ISService">  
                                            {{item.CompPrice}}
                                        </td>
                                    </tr>
                                    <tr *ngIf="!ISService"> 
                                        <td colspan="4" class="text-center">
                                            <table class="table ">
                                                <thead>
                                                    <tr>
                                                        <th
                                                            *ngFor="let CSAitem of item?.CsaRate | getCompCsaRateGreaterThenZero">
                                                            {{CSAitem.CounterDesc}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            *ngFor="let CSAitem of item?.CsaRate | getCompCsaRateGreaterThenZero">
                                                            {{CSAitem.Rate}}
                                                        </td>
        
                                                    </tr>
                                                </tbody>
                                            </table>
        
                                        </td>
                                    </tr>
                                </ng-container>
        
                            </tbody>
                        </table>
        
        
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>

<!-- <div class="form-group row">
    <div class="col-sm-12">
        <app-spra-approval-remarks></app-spra-approval-remarks>
    </div>
 
</div> -->
  
                <!-- Added by rahul yadav on 15/7/2021 in case of DayOneCSA  -->
                <mat-card *ngIf="SPRADetail?.PriceApproval?.DayOneCSA">
                    <mat-card-title class="font-weight-bold caption-color"></mat-card-title>
                    <mat-divider></mat-divider>
                    <mat-card-content class="pt-2">
                    <div class="row" >
                        <div class="col-sm-12" *ngIf="SPRADetail.CsaRate.length>0 && SPRADetail.SaleType!='LL'" >
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Counter</th>
                                        <th>ExistingCSARate</th>
                                        <th> Order Rate </th>
                                        <th *ngIf="ProfitTag"> Price List </th>
                                        <th *ngIf="ProfitTag"> Landed Cost-Worksheet </th>
                                        <th *ngIf="ProfitTag"> GP% </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of SPRADetail.CsaRate; let i = index;">
                                        
                                        <td>
                                            {{item.CounterDesc}}
                                        </td>
                                        <td>
                                            
                                            {{item.ExistingCSARate!=""?item.ExistingCSARate:"NA"}}
                                        </td>
                                        <td>
                                            {{item.OrderRate}}
                                        </td>
                                        <td *ngIf="ProfitTag"> {{item.PriceList}} </td>
                                        <td *ngIf="ProfitTag"> {{item.WorkSheetLanded}} </td>
                                        <td *ngIf="ProfitTag"> {{item.GP}} % </td>
                                       
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    
                    </div>
                    </mat-card-content>
                    </mat-card>

<div class="form-group row" >
    <div class="col-sm-12" *ngIf="SPRADetail!=undefined && SPRADetail.IsRental && !ISService ">
        <!-- *ngIf="SPRADetail.Amcv.CounterDetail.length>0" -->
        <!-- && SPRADetail.Amcv != undefined  -->
        <mat-card >
        <mat-card-title class="font-weight-bold caption-color">Contract Detail</mat-card-title>
        <mat-divider></mat-divider>
        <mat-card-content class="pt-2">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Service Contract Period</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.MachineLife}} </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Cont. Period (In Months)</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.ContPeriod}} </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Lock (In Months)</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.LockInMonths}} </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Security Deposite</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.SecurityDeposite}} </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Monthly Rent</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.MonthlyRent}} </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Lease Type</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.LeaseType}} </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Residual Value</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.ResidualValue}} </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">Rate Of Interest</div>
                        <span class="col-sm-2"> : </span>
                        <div class="col-sm-6 font-weight-bold">{{SPRADetail?.Amcv?.RateOfInterest}} </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4">  <span *ngIf="SPRADetail.Amcv?.NotionalRent" class="floating badge badge-pill badge-primary" (click)="EnterNotionalRentDetail()"> Notional Rent Detail </span></div>
                        <span class="col-sm-2">  </span>
                        <div class="col-sm-6 font-weight-bold"></div>
                    </div>
                </div>
               
               
    
            </div>
            
            <div class="row" *ngIf="SPRADetail.Amcv.CounterDetail.length>0 && SPRADetail.Amcv != undefined" >
                <div class="col-sm-12" >
    
    
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Copy</th>
                                <th class="text-right"> Agreed CSA Rate </th>
                                <th class="text-right"> Customer Commitment Copy Per Month</th>
                                <th class="text-right">Agreed Free Copies</th>
                                <th class="text-right"> Estimated Monthly Copy Load </th>
                                <th class="text-right"> Total Copy </th>
                                <th class="text-right" *ngIf="ProfitTag">Std CSA Rate(Rs per copy)</th>
                                <th class="text-right" *ngIf="ProfitTag">CSA Cost Rate(Rs per copy)</th>
                                <th class="text-right" *ngIf="ProfitTag">CSA GP(%)(Rs per copy)</th>
                            </tr>
                        </thead>
                        <tbody>
    
    
                            <tr *ngFor="let item of SPRADetail.Amcv.CounterDetail; let i = index;">
                                <td>
                                    {{item.CounterDesc}}
                                </td>
                                <td class="text-right">
                                    {{item?.AgreedCSARate}}
                                </td>
                                <td class="text-right">
                                    {{item?.CustomerCommitmentCopy}}
                                </td>
                                <td class="text-right">
                                    {{item?.AgreedFreeCopy}}
                                </td>
                                <td class="text-right">
                                    {{item?.EMCL}}
                                </td>
                                <td class="text-right">
                                    {{item?.TotalCopy}}
                                </td>
    
                                <td class="text-right" *ngIf="ProfitTag">
                                    <label>{{item?.StdCSARate| number : '1.2-2'}}</label>
                                </td>
    
                                <td class="text-right" *ngIf="ProfitTag">
                                    <label>{{item?.CSACostRate| number : '1.2-2'}}</label>
                                </td>
    
                                <td class="text-right" *ngIf="ProfitTag">
                                    <label>{{item?.CSAGP| number : '1.2-2'}}%</label>
                                </td>
    
    
                            </tr>
    

                            <tr class="bg-highlight" *ngIf="ProfitTag">
                                <td colspan="8">
                                    Service Revenue loss towards Free Copies (CSA Cost Rate x Free Copy)
                                </td>
                            <td class="text-right" *ngIf="ProfitTag">
                                <label>{{SPRADetail?.Amcv?.FreeCopyValue| number : '1.2-2'}}</label>
                                
                            </td>
                            </tr>
                            <tr class="bg-highlight" *ngIf="ProfitTag">
                                <td colspan="9" ><b>Monthly Rent towards Machine</b></td>

                            </tr>
                            <tr class="bg-highlight" *ngIf="ProfitTag">
                                <td colspan="8">
                                    Fixed Rent towards M/c Rent less Notional Free Copy (Rs) Per Copy Contract
                                </td>
                            <td class="text-right" *ngIf="ProfitTag">
                                <label>{{ (SPRADetail?.Amcv?.MonthlyRent- SPRADetail?.Amcv?.FreeCopyValue)| number : '1.2-2'}}</label>
                                
                            </td>

                            </tr>

                        </tbody>
                    </table>
    
                </div>
            </div>
        </mat-card-content>
    </mat-card>

</div>
</div>



<div class="form-group row" >
    <div class="col-sm-12" *ngIf="SPRADetail!=undefined && SPRADetail.Amcv != undefined && !SPRADetail.IsRental">
        <mat-card *ngIf="SPRADetail.Amcv.CounterDetail.length>0">
            <mat-card-title class="font-weight-bold caption-color">AMCV</mat-card-title>
            <mat-divider></mat-divider>
            <mat-card-content class="pt-2">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <div class="col-sm-3 ml-4">Life of Machine</div>
                            <span class="col-sm-1"> : </span>
                            <div class="col-sm-2 font-weight-bold">{{SPRADetail?.Amcv?.MachineLife}} </div>
                        </div>
                    </div>
                   
                </div>
                <div class="col-sm-12">                  
                    <div *ngIf="SPRADetail?.PriceApproval?.DayOneCSA" class="col-sm-12">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Copy</th>
                                    <th> Existing AMCV </th>
                                    <th> Estimated Monthly Copy Load </th>
                                    <th> Total Copy </th>

                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Total Sale Value</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Price-List</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Worksheet-Net Sales Price</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">LC-Worksheet</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Book LC</th> 

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of SPRADetail.AMCV_CSA; let i = index;">
                                    <td>
                                        {{item.CounterDesc}}
                                    </td>
                                    <td>
                                        {{item?.ExistingAMCV}}
                                    </td>
                                    <td>
                                        {{item?.EMCL}}
                                    </td>
                                    <td>
                                        {{item?.TotalCopy}}
                                    </td>

                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label class="pr-5">{{item?.TotSaleVal| number : '1.0-0'}}</label>
                                    </td>
                                    
                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label class="pr-5">{{item?.PriceList| number : '1.0-0'}}</label>
                                    </td>
                                    
                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label class="pr-5">{{item?.WorkSheetNSP| number : '1.0-0'}}</label>
                                    </td>
                                    
                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label class="pr-5">{{item?.WorkSheetLanded| number : '1.0-0'}}</label>
                                    </td>

                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label class="pr-5">{{item?.BookingLanded| number : '1.0-0'}}</label>
                                    </td>


                                </tr>


                                <tr *ngIf="!ISService && ProfitTag" class="bg-highlight">
                                    <td colspan="4">
                                        <b>Net Sale Price Released</b>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalSale | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalPriceList | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalWSNSP | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalLandedCost | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalBookLC | number : '1.0-0'}}</b></label>
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="!ISService && ProfitTag" class="bg-highlight">
                                    <td colspan="5">
                                        <b>Service GP (%) BEING REALISED AGAINST THIS ORDER </b>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPriceList}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPWSNSP}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPLandedCost}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPBookLC}}</b></label>
                                    </td>
                                    
                                </tr>


                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="!SPRADetail.PriceApproval?.DayOneCSA">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Copy</th>
                                    <th> Existing AMCV </th>
                                    <th> Estimated Monthly Copy Load </th>
                                    <th> Total Copy </th>
                                    <th> Cons. Part Code </th>
                                    <th>Cons. Total Qty Consumption</th>
                                    <th>Cons. Unit Price </th>

                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Total Sale Value</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Price-List</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Worksheet-Net Sales Price</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">LC-Worksheet</th>
                                    <th *ngIf="!ISService && ProfitTag" class="text-right">Book LC</th> 


                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of SPRADetail.AMCV_Product; let i = index;">
                                    <td>
                                        {{item.CounterDesc}}
                                    </td>
                                    <td>
                                        {{item?.ExistingAMCV}}
                                    </td>
                                    <td>
                                        {{item?.EMCL}}
                                    </td>
                                    <td>
                                        {{item?.TotalCopy}}
                                    </td>

                                    <td>
                                        {{item?.ProductCode}}
                                    </td>
                                    <td>
                                        {{item?.TotalQtyConsumption}}
                                    </td>
                                    <td>
                                        {{item?.Price}}
                                    </td>
                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label>{{item?.TotSaleVal| number : '1.0-0'}}</label>
                                    </td>
                                    
                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label>{{item?.PriceList| number : '1.0-0'}}</label>
                                    </td>
                                    
                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label>{{item?.WorkSheetNSP| number : '1.0-0'}}</label>
                                    </td>
                                    
                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label>{{item?.WorkSheetLanded| number : '1.0-0'}}</label>
                                    </td>

                                    <td *ngIf="!ISService && ProfitTag" class="text-right">
                                        <label>{{item?.BookingLanded| number : '1.0-0'}}</label>
                                    </td>


                                </tr>


                                <tr *ngIf="!ISService && ProfitTag" class="bg-highlight">
                                    <td colspan="7">
                                        <b>Net Sale Price Released</b>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GrandTotSale | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GrandTotPriceList | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalWSNSP | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalLandedCost | number : '1.0-0'}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.TotalBookLC | number : '1.0-0'}}</b></label>
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="!ISService && ProfitTag" class="bg-highlight">
                                    <td colspan="8">
                                        <b>Service GP (%) BEING REALISED AGAINST THIS ORDER </b>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPriceList}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPWSNSP}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPLandedCost}}</b></label>
                                    </td>
                                    <td class="text-right">
                                        <label><b>{{SPRADetail.PriceRefCalculations?.AMCV.GPBookLC}}</b></label>
                                    </td>
                                    
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>    
</div>
<!-- Added by rahul yadav on 15/7/2021 in case of upload view -->
<div class="form-group row " *ngIf="SPRADetail && SPRADetail.Documents != undefined && SPRADetail.Documents.length > 0">
<div class="col-sm-6">
    <mat-card>
        <mat-card-title class="font-weight-bold caption-color"> Document View <span class="font-red-flamingo">[PDF]</span>
        </mat-card-title>
        <mat-divider></mat-divider>
        <mat-card-content class="pt-2 ">                        
            <app-multiple-file-upload></app-multiple-file-upload>
        </mat-card-content>
    </mat-card>

</div>
</div>
<!-- <div class="form-group row " *ngIf="SPRADetail && ProfitTag"> -->
<div class="form-group row " *ngIf="SPRADetail">        <!-- ProfitTag Removed -->
        
                <div class="col-sm-6" *ngFor="let item of SPRADetail.AppDetail; let i = index;">
                    <mat-card class="{{i%2==0?'mt-3 ml-3':'mt-3'}}" *ngIf="item.Tag==1">
                        <mat-card-title class="font-weight-bold caption-color">Level {{item.LevelID}}
                            <span *ngIf="ParentSpraDetails!=undefined && ParentSpraDetails.length > 0 && i == SPRADetail.AppDetail.length - 2">
                                [Original spra:<button type="button"  class="btn btn-link" (click)="onRequestClick();">{{ParentSpraDetails[0].RequestNo}}]</button>
                            </span>
                        </mat-card-title>
                      
                        <mat-divider></mat-divider>
                        <mat-card-content class="pt-2">
                            <div class="row">
                                <div class="col-sm-3 ">Status</div>
                                <span class="col-sm-1"> : </span>
                                <div class="col-sm-8 font-weight-bold">{{item.AppStatus}} </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3" *ngIf="item.IsRequest==1">Requested By</div>
                                <div class="col-sm-3" *ngIf="item.IsRequest==0">Approved By</div>
                                <span class="col-sm-1"> : </span>
                                <div class="col-sm-8 font-weight-bold">{{item.ApprovedBy}} </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3" *ngIf="item.IsRequest==1">Requested Date</div>
                                <div class="col-sm-3" *ngIf="item.IsRequest==0">Approved Date</div>
                                <span class="col-sm-1"> : </span>
                                <div class="col-sm-8 font-weight-bold">{{item.ApprovedDate}} </div>
                            </div>
        
                            <div class="row">
                                <div class="col-sm-3 ">Remarks</div>
                                <span class="col-sm-1"> : </span>
                                <div class="col-sm-8 font-weight-bold">{{item.Remarks}} </div>
                            </div>
                        </mat-card-content>
        
        
                    </mat-card>

                </div>
        
</div>